import { SuggestionUpdateDto } from '@interfaces/suggestionInterface';
import { suggestionService } from '@services/index';
import { useMutation } from '@tanstack/react-query';

export default function useMutationUpdateSuggestion() {
	return useMutation({
		mutationFn: (suggestionDto: SuggestionUpdateDto) => suggestionService.updateDecision(suggestionDto)
	});
}
